module.exports = __webpack_public_path__ + "media/cuu/logo_65_aniv_ensech_cintillo-6b9c7270.png";